exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".scrollable.next-wrapper {\n\tpadding: 71px 0 108px;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/rubylover/Work/new_vin_photo/site/web/src/app/next/next.component.css
// module id = ../../../../../src/app/next/next.component.css
// module chunks = main